export { DMS_MODULE } from '../constants';
export const NAME = 'WmsTechnician';
export const API_NAME = 'WmsTechnician';
export const CRUMB_LABEL_KEY = 'WmsTechnician';
